import { routeTo } from "../../../Components/CustomHooks/routeChange";
import { BaseAction } from "../../../core/actions/BaseAction";
import { calculatePrice } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { clearBookingFlowAtoms } from "../../../Orchestrator/Recoils/clearBookingFlowAtoms";
import { TripTypeEnum, TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedOffer, IBookingTypeTrip, IReservation } from "../../../Orchestrator/Types/Index";
import { IAlreadyAddonsLegPassengerAddons, IAlreadyAddonsForPassenger, IBookingLegWiseAddonsForCancelTrip } from "../../../Orchestrator/Types/Interface/IAddOns";
import { IPaymentItemDetails } from "../../../Orchestrator/Types/Interface/IPayment";
import { getBookingAction } from "../../LogicActions/Booking/GetBookingAction";
import { cleanupOrphanAddonsAction } from "../../LogicActions/Addons/CleanupOrphanAddonsAction";


export class CancelBookingRedirectClickAction extends BaseAction<void, {
    isFrom: string,
    bookingId: string,
    route: string,
    tripData: any,
    previousRoute?: string
}> {
    override async run(): Promise<void> {
        try {

            const { isFrom, bookingId, route, tripData, previousRoute } = this.params!;
            // Wipe stale flow state from any prior aborted checkout before
            // seeding this flow's writes (see clearBookingFlowAtoms doc).
            clearBookingFlowAtoms();
            updateRecoilState("selectedPassengerForCancelAtom", []);
            updateRecoilState("selectedPassengerForCancelInBoundAtom", []);
            updateRecoilState("paymentOutBoundItemsDetailsAtom", null);
            updateRecoilState("paymentInboundItemsDetailsAtom", null)
            updateRecoilState("selectedBookingIdForCancelAtom", bookingId);
            updateRecoilState("displayPassengerDataAtom", tripData.passengers);
            updateRecoilState("selectedTripsDataAtom", tripData);
            
            const routeToStore = previousRoute || (typeof window !== "undefined" ? window.location.pathname : "");
            if (routeToStore) {
                updateRecoilState("cancelBookingPreviousRouteAtom", routeToStore);
            }

            // Pass filtering parameters to GetBookingAction
            const getBookingParams = {
                bookingId,
                direction: tripData.direction,
                displayPassengerData: tripData.passengers,
                selectedTripsData: tripData
            };
            getBookingAction.setParams(getBookingParams);
            await getBookingAction.execute();
            // Strip orphan PREBOOKED ancillaries from a prior abandoned
            // manage-seating / addons session before we use the booking.
            await cleanupOrphanAddonsAction.execute();
            // If cleanup deleted anything, re-fetch so the response below
            // reflects the post-cleanup booking. Otherwise orphan PREBOOKED
            // ancillaries leak into bookingLegWiseAddonsForCancelTripAtom.
            if (cleanupOrphanAddonsAction.result?.cleaned) {
                getBookingAction.setParams(getBookingParams);
                await getBookingAction.execute();
            }

            const response: any = getBookingAction.result;
            let allBookedOfferWithoutExchange: IBookedOffer[] = response?.allBookedOfferWithoutExchange || []
            let allBookedTripWithoutExchange: IBookingTypeTrip[] = response?.allBookedTripsWithoutExchange || []
            let bookingLegWiseAddons: IBookingLegWiseAddonsForCancelTrip = {
                outbound: {
                    addons: [],
                    total: 0
                },
                inbound: {
                    addons: [],
                    total: 0
                }
            }
            if (allBookedOfferWithoutExchange.length > 0 && allBookedTripWithoutExchange.length > 0) {
                allBookedOfferWithoutExchange.forEach((bookedOffer: IBookedOffer) => {
                    const transformedMealOptions: IPaymentItemDetails[] = [];
                    let bookTrip = allBookedTripWithoutExchange.find(d => d.id === bookedOffer?.tripCoverage?.coveredTripId)
                    const allAncillaryForTrip = bookedOffer.ancillaries.filter(d => d?.tripCoverage?.coveredTripId === bookTrip?.id && d.status !== "REFUNDED")
                    for (const ancillaries of allAncillaryForTrip) {
                        const productId = ancillaries.products[0].productId
                        const productDetails = bookedOffer.products.find(d => d.id === productId)
                        const transformedMeal: IPaymentItemDetails = {
                            amount: calculatePrice(ancillaries.price),
                            category: productDetails?.description || "",
                            description: productDetails?.description || "",
                            status: "Active",
                            passengerId: ancillaries.passengerIds[0]
                        };
                        transformedMealOptions.push(transformedMeal);
                    }

                    // const aggregateAddons = (items: IPaymentItemDetails[]) =>
                    //     items.reduce((acc: Record<string, { amount: number; count: number }>, item) => {
                    //         const categoryText = item?.category || "";
                    //         if (!acc[categoryText]) {
                    //             acc[categoryText] = { amount: 0, count: 0 };
                    //         }
                    //         acc[categoryText].amount += item.amount;
                    //         acc[categoryText].count += 1;
                    //         return acc;
                    //     }, {});
                    // const activeItems = transformedMealOptions.filter(item => item.status === "Active");
                    // const canceledItems = transformedMealOptions.filter(item => item.status === "Canceled");
                    // const activeCount = aggregateAddons(activeItems);
                    // const canceledCount = aggregateAddons(canceledItems);

                    // const finalActiveAddons = Object.keys(activeCount).map(category => ({
                    //     amount: activeCount[category].amount,
                    //     description: `${activeCount[category].count} ${category}`,
                    // }));

                    // const finalCanceledAddons = Object.keys(canceledCount).map(category => ({
                    //     amount: canceledCount[category].amount,
                    //     description: `${canceledCount[category].count} ${category} (Canceled)`,
                    // }));
                    // const finalAddons = [...finalActiveAddons, ...finalCanceledAddons]

                    let direction: TrainTypeEnum = (bookTrip?.direction || "") === TripTypeEnum.IN_BOUND ? TrainTypeEnum.inbound : TrainTypeEnum.outbound
                    // Accumulate. This assigned, so the LAST offer of a direction
                    // won and every earlier offer's addons were discarded — on
                    // 5HQ2PP the offers are [shuttle, train+Reem, shuttle], so the
                    // trailing shuttle wiped the "Shuttle From/To Reem Mall" row
                    // while `total` (+=, below) still counted its AED 10. That is
                    // why the summary itemised 170 under a 180 total.
                    bookingLegWiseAddons[direction].addons = [
                        ...bookingLegWiseAddons[direction].addons,
                        ...transformedMealOptions
                    ]
                    const totalPrice = (transformedMealOptions || []).reduce((price, item) => price += item.amount, 0)
                    bookingLegWiseAddons[direction].total = (bookingLegWiseAddons[direction]?.total || 0) + totalPrice
                })                
                updateRecoilState("bookingLegWiseAddonsForCancelTripAtom", bookingLegWiseAddons)
            }

            routeTo(route);

        } catch (error) {
            console.error("Error during back to booking click action:", error);
        }
    }
}

export const cancelBookingRedirectClickAction = new CancelBookingRedirectClickAction();
